import React from 'react';
import { Card } from "react-bootstrap";
import face_gergo_orban from "../../assets/img/face_gergo_orban.jpg";
import ShowMoreText from "react-show-more-text";
import proj_representation_learning_using_deepgen_models from "../../assets/img/proj_representation_learning_using_deepgen_models.png";

const Gergo_Orban_repr_learning = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_representation_learning_using_deepgen_models} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gergo_orban}
              /* this will be the text on the banner */
              alt="Representation learning using deep generative models"
            />{" "}
            <p className="text7">Gergő Orbán</p>
            <br />
            <p className="text8">
              Group Leader{" "}
            </p>
            <p className="text8">Wigner Research Centre for Physics</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Machine learning has recently achieved breakthroughs by developing deep discriminative 
            models (commonly termed deep learning models) that are capable of human-level learning 
            about natural-complexity images. A drawback of these methods is that they require labeled 
            data: for every single input image a desired output is required. In more general learning 
            settings such labels are not available. A more recent advance in machine learning is the 
            development of Variational Autoencoders, a model class that is performing learning in an 
            unsupervised fashion. These models are attractive since they promise to discover the 
            features underlying observations automatically, a topic called representation learning, 
            which is also the basis of learning representations that can flexibly adapt to novel tasks. 
            The goal of the research is to reveal the boundary conditions of learning, the so called 
            inductive biases, which can effectively shape the hierarchical representations learned on natural images.

            <br />
            <br />

            The research topic provides an opportunity to work on a hot topic in machine learning, 
            to get familiar with topics such as probabilistic generative models, Bayesian methods, 
            deep learning, and to get to know modern programming environments. The research has a 
            component in biological learning, which also provides a unique opportunity to investigate 
            the way machine learning tools help discoveries in neuroscience.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gergo_Orban_repr_learning;